// extracted by mini-css-extract-plugin
export default {"wrapper":"Uw-z","viewport":"Vw-z","container":"Ww-z","slide":"Xw-z"};